export default __webpack_public_path__ + "static/media/circle-check.a69e5d02.svg";